module.exports = __webpack_public_path__ + "img/avatar.3e507d35.svg";